import { _ as _extends } from './_rollupPluginBabelHelpers-c7687d88.js';
import React__default from 'react';
import cx from 'classnames';

var styles = {"content":"Content-module_content__EnZoh","center":"Content-module_center__1Fljl"};

const ContentBase = ({
  center,
  children,
  className,
  element,
  forwardedRef,
  wrapper,
  wrapperContentPost,
  wrapperContentPre,
  ...p
}) => {
  const ContainerElement = element || 'div';
  let content = /*#__PURE__*/React__default.createElement(ContainerElement, _extends({
    className: cx(styles.content, className, {
      [styles.center]: center
    }),
    ref: forwardedRef
  }, p), children);
  if (wrapper) {
    content = /*#__PURE__*/React__default.createElement("div", wrapper, wrapperContentPre, content, wrapperContentPost);
  }
  return content;
};
const Content = /*#__PURE__*/React__default.forwardRef((props, ref) => /*#__PURE__*/React__default.createElement(ContentBase, _extends({}, props, {
  forwardedRef: ref
})));

export { Content as default };
